import { useQuery } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../../../_hooks/useClientId';
import { queryKeys } from './queryKeys';

interface FetchParams {
  clientId: number;
  contextId: string;
}

interface Response {
  isCompleted: boolean;
}

export const fetchExternalAccountProvidersPoll = async ({
  clientId,
  contextId,
}: FetchParams): Promise<Response> => {
  return authFetch(
    urlWithParams('/Consumer/ExternalAccessAccountsProviders/Poll', { clientId, contextId }),
  );
};

interface QueryParams {
  contextId: string;
}

export const useExternalAccountProvidersPollQuery = ({ contextId }: QueryParams) => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.externalAccountProvidersPoll(clientId, contextId),

    () => fetchExternalAccountProvidersPoll({ clientId, contextId }),

    {
      cacheTime: 0,
      refetchInterval: 3000,
    },
  );
};
